import api from "../../../services/api";
import gridClientBase from "../../../components/gridClientComponentBase";
import cellDeleteCommand from "../../../components/grid/cellDeleteCommand/cellDeleteCommand.vue";
import cellTemplate from "../../../components/grid/cellTemplate/cellTemplate.vue";

export default {
	extends: gridClientBase,
	components: {},

	data: function() {
		return {
			loading: false,
			savePendingRequest: null
			// items: []
		};
	},

	created() {
		this.getData(1);
		var newItem = {
			box_payload_id: "",
			box_type_id: "",
			description: "",
			id: this.indexNewItem,
			name: "",
			percentage_max_tolerance: 0,
			percentage_min_tolerance: 0
		};
		this.defaultAddRow = newItem;
		this.sort = [{ field: "name", dir: "asc" }];
	},

	/* metodi */
	methods: {
		saveData: function() {
			var self = this;
			if (this.savePendingRequest == null) {
				this.savePendingRequest = api
					.postVehicleEventsData(this.createdItems, this.updatedItems, this.deletedItems)
					.then(res => {
						self.createdItems = [];
						self.updatedItems = [];
						self.deletedItems = [];

						self.isInEditMode = false;
						self.getData();
					})
					.catch(err => {
						console.log("KO" + err);
					})
					.finally(_ => {
						self.savePendingRequest = null;
					});
			}
		},

		getData: function() {
			var self = this;
			this.loading = true;

			this.getVehicleEvents(self);
		},

		getVehicleEvents: function(self) {
			api.getVehicleEventsData().then(res => {
				self.loading = false;
				self.items = res.map(function(item) {
					return {
						name: item.name,
						description: item.description,
						box_payload_id: item.box_payload_id,
						box_type_id: item.box_type_id,
						id: item.id,
						percentage_min_tolerance: item.percentage_min_tolerance,
						percentage_max_tolerance: item.percentage_max_tolerance
					};
				});
			});
		},

		switchEditMode() {
			this.isInEditMode = !this.isInEditMode;

			if (!this.isInEditMode) {
				this.clearWorkingData();
				this.getData();
			}

			this.savePendingRequest = null;
		},

		isColumnFilterable(field) {
			if (this.columns) {
				var c = this.columns.find(function(f) {
					return f.field == field;
				});

				if (c && c.filterable) {
					return true;
				}
			}

			return false;
		}
	},

	/* visualizzazione risultati */
	computed: {
		columns: function() {
			return [
				{
					field: "name",
					title: "nome",
					cell: "myCellTemplate",
					width: "170",
					minResizableWidth: "150",
					headerCell: "myHeaderTemplate",
					filterable: true
				},
				{
					field: "description",
					title: "descrizione",
					cell: "myCellTemplate",
					width: "193",
					minResizableWidth: "150",
					headerCell: "myHeaderTemplate",
					filterable: true
				},
				{
					field: "box_payload_id",
					title: "id box",
					cell: "myCellTemplate",
					width: "75",
					minResizableWidth: "35",
					headerCell: "myHeaderTemplate"
				},
				{
					field: "box_type_id",
					title: "tipologia",
					cell: "myCellTemplate",
					width: "120",
					minResizableWidth: "110",
					headerCell: "myHeaderTemplate",
					filterable: true
				},
				{
					field: "box_cat_id",
					title: "categoria",
					cell: "myCellTemplate",
					width: "120",
					minResizableWidth: "110",
					headerCell: "myHeaderTemplate",
					filterable: true
				},
				{
					field: "",
					title: "",
					cell: "myCellTemplate",
					width: "",
					headerCell: "",
					filterable: false,
					sortable: false
				}
			];
		}
	}
};
